import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function FAQSchema() {
  const {
    t
  } = useLanguage();
  const faqs = t('faq.items');
  if (!Array.isArray(faqs)) return null;
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq: any) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(schema)
  }} data-id="element-87" />;
}